import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Container, Row } from 'reactstrap';
import {Card, Grid } from '@mui/material';
import { Box } from '@mui/system';  // Example import
import SubCard from '../../ui-component/cards/SubCard';
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import Flatpickr from 'react-flatpickr';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
// import buttonsData from '../../Data/reportPage.json';
import { Link } from 'react-router-dom';
import PowerBiReportPage from './SubPages/PowerBiReportPage';
import { styled, useTheme } from '@mui/styles';
import { Avatar, Menu } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SET_REPORT_DATA } from '../../store/actions';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import appointment from '../../assets/images/icons/appointment-red.png';
import speedometer from '../../assets/images/icons/speedometer.png';

function Reports() {
    const [age, setAge] = React.useState('All Fleets');
    // const handleChange = (event) => {
    //     setAge(event.target.value);
    // };
    const downloadTxtFile = () => {
        window.location.href = 'https://hackathon-participants-assets.s3.ap-south-1.amazonaws.com/rta.xlsx';
    };

    const buttonsData = [
        {
            // "title": "Revenue report",
            title: 'Production Details',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiZDBkZmRlMWUtY2M1Ny00NGQyLWE3YmItNGY2NzRhZDViY2FhIiwidCI6ImZlM2U5MWVmLTQzODktNDk4NS1hZTg5LTk0YTY1MjMwNjE3YSJ9'
        },
        {
            // "title": "Profit and Loss",
            title: 'Active report',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiYjQ4OGRhMmItNDYyZC00NWM1LWEzYjMtZjgyOWVhNmQzMmU2IiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        },
        {
            title: 'Cost of Manpower per vehicle- fleet wise',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiMjM3YWE3NjUtMmY3MC00NDcwLWE3Y2QtNDkxOGQ3Yzk5MTNiIiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        },
        {
            title: 'Profit and loss- Month on month and cumulative YTD',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiNGJhZjRmNzEtZDg5My00ZWEzLWJlZWQtMjk5YTFhYTAwZTI4IiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        },
        {
            title: 'Revenue report- Month on month and cumulative YTD',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiY2M1N2U3ZTEtODI1My00NWQ1LWEyYWEtYzVhNTU3NmQ4OTM0IiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        },
        {
            title: 'Tyre Information Report',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiNTA3NTI4MmYtZDUxMS00MDE4LWFhMzYtZDBkYmRmMDY1MTIyIiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        },
        {
            title: 'Fleetwise wise damaged tyres',
            link: '/power-bi-report-page',
            embedUrl:
                'https://app.powerbi.com/view?r=eyJrIjoiYTc5ZjhhNTUtYWJkYi00OTk1LWI2OGQtOGI2OTU1MzA3OWQ4IiwidCI6IjFlNmIzZWUzLTQ4NWQtNGJlMC1iZGQwLWFkYTRhYTM1ZTVlNCJ9'
        }
        // {
        //     "title": "Fleetwise tyre life estimated v/s actual kms run",
        //     "link": "/power-bi-report-page",
        //     "embedUrl": "",

        // },
        // {
        //     "title": "Repair cost per vehicle",
        //     "link": "/power-bi-report-page",
        //     "embedUrl": "",

        // }
    ];

    const CardWrapper = styled(MainCard)(({ theme }) => ({
        backgroundColor: '#F44336',
        overflow: 'hidden',
        position: 'relative',
        alignItems: 'center',
        textAlign: 'center',
        height: 100,
        color: 'white',
        paddingTop: '10px',
        '&:after': {
            content: '""',
            position: 'absolute',
            width: 210,
            height: 210,
            background: '#f6b9b99a',
            borderRadius: '50%',
            top: -85,
            right: -95,
            [theme.breakpoints.down('sm')]: {
                top: -105,
                right: -140
            }
        },
        '&:before': {
            content: '""',
            position: 'absolute',
            width: 210,
            height: 210,
            background: '#f6b9b99a',
            borderRadius: '50%',
            top: -125,
            right: -15,
            opacity: 0.5,
            [theme.breakpoints.down('sm')]: {
                top: -155,
                right: -70
            }
        }
    }));

    const dispatch = useDispatch();

    const handleButtonClick = (buttonData) => {
        localStorage.setItem('URL', buttonData.embedUrl);
        localStorage.setItem('title', buttonData.title);
        dispatch({
            type: SET_REPORT_DATA,
            payload: {
                reportData: buttonData.embedUrl,
                title: buttonData.title
            }
        });
    };

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const customization = useSelector((state) => state.customization);
    console.log(customization);

    if(customization.payload){

    }

    return (
        <>
            <MainCard title={customization.payload? customization.payload.title: ""} secondary={<SecondaryAction />}>
                <Grid container spacing={gridSpacing}>
                
                    <Grid item xs={12} lg={12} md={12} sm={12}>
                        <Container fluid>
                                {/* <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Profit & Loss</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Company P&L</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Production P&L</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Purchase P&L</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Image-I P&L(Virtual P&L)</Typography>
                                    </AccordionSummary>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Reconciliation of Virtual P&L and ERP P&L</Typography>
                                    </AccordionSummary>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Exception Report</Typography>
                                    </AccordionSummary>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Production Analysis</Typography>
                                    </AccordionSummary>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Sales Analysis</Typography>
                                    </AccordionSummary>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className="mouseHover">
                                        <Typography>Daily Reports-Conceptual Reports</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Daily Sales</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Daily Production</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Daily Gross Profit</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                            <Accordion onClick={()=>{}} sx={{ cursor: "pointer" }} className="mouseHover">
                                                <AccordionSummary
                                                    // expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography>Daily Yield</Typography>
                                                </AccordionSummary>
                                            </Accordion>
                                        </Typography>
                                    </AccordionDetails>
                                </Accordion> */}
                            <div className="container top_rp_cn">
                                <Row className="gy-3 ">
                                    <Col lg={4}>
                                        {/* <div>
                                            <Flatpickr
                                                className="form-control fp_w"
                                                placeholder="Start Date"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "Y-m-d H:i",
                                                }}
                                            />
                                        </div> */}
                                    </Col>
                                    <Col lg={4}>
                                        {/* <div>
                                            <Flatpickr
                                                className="form-control fp_w"
                                                placeholder="End Date"
                                                options={{
                                                    enableTime: true,
                                                    dateFormat: "Y-m-d H:i",
                                                }}
                                            />
                                        </div> */}
                                    </Col>
                                    <Col lg={4}>
                                        {/* <div
                                            className="d-flex "                                        >
                                            <Select
                                                labelId="demo-select-small"
                                                id="demo-select-small"
                                                value={age}
                                                label="Age"
                                                onChange={handleChange}
                                                className="rp_sl"
                                            >
                                                <MenuItem value={'All Fleets'}>
                                                    All Fleets
                                                </MenuItem>
                                                <MenuItem value={10}>Company 1</MenuItem>
                                                <MenuItem value={20}>Company 2</MenuItem>
                                                <MenuItem value={30}>Company 3</MenuItem>
                                                <MenuItem value={30}>Company 4</MenuItem>

                                            </Select>
                                        </div> */}
                                    </Col>
                                </Row>
                                {/* <div className="mt-5" style={{ marginBottom: "5rem" }}>
                                    <Row className="gy-3">
                                        <Col lg={12}>
                                            <div
                                                className="d-flex"
                                                style={{ alignItems: "center", justifyContent: "center" }}
                                            >
                                                <Button className="px-5 download_btn_rp" onClick={downloadTxtFile}>Download CSV</Button>
                                            </div>
                                        </Col>


                                    </Row>
                                </div> */}
                                {/* <Divider /> */}
                                
                                <br></br>
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={gridSpacing}>
                                            {buttonsData.map((button, index) => (
                                                <Grid item lg={4} md={6} sm={6} xs={12}>
                                                    <Link to={button.link} style={{ width: '100%', textDecoration: 'none' }}>
                                                        <CardWrapper border={false} content={false} className="CardWrapper" onClick={() => handleButtonClick(button)}>
                                                            <Box sx={{ p: 2.25 }}>
                                                                <Grid container direction="column">
                                                                    <Grid item>
                                                                        <Grid container justifyContent="center" alignItems="center">
                                                                            <Grid item>
                                                                                <Typography sx={{ fontSize: '1rem', fontWeight: 700, mr: 1, mt: 1.75, mb: 0.75 }}>
                                                                                    {button.title}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </CardWrapper>
                                                    </Link>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </Container>
                    </Grid>
                </Grid>
            </MainCard>

            <Grid Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">
                            &copy; {new Date().getFullYear()} IMAGE-I 
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default Reports;
